import { useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';

export type JourneyItem = {
  id?: string;
  type?: string;
  role?: string;
  name?: string;
  content?: string;
  new_agent_id?: string;
  message?: string;
  arguments?: string;
  output?: string;
  call_id?: string;
  created_at?: number;
  extra?: { hidden?: string; speaker?: string };
};

const formatToolJson = (value: string) => {
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

export default function TranscriptToolRow({
  variant,
  title,
  callId,
  content,
  timestamp
}: {
  variant: 'invocation' | 'result';
  title: string;
  callId?: string;
  content: string;
  timestamp?: string;
}) {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);
  const color = variant === 'invocation' ? theme.palette.primary.main : theme.palette.success.main;

  return (
    <Box my={1}>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        sx={{ cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <Box display='flex' alignItems='center' gap={0.75}>
          {expanded ? <IoChevronUp size={14} color={color} /> : <IoChevronDown size={14} color={color} />}
          <Typography fontSize={13} fontWeight={500} color={color}>
            {title}
          </Typography>
        </Box>
        {timestamp && (
          <Typography fontSize='11px' color='text.secondary'>
            {timestamp}
          </Typography>
        )}
      </Box>
      {expanded && (
        <Box
          mt={0.75}
          p={1.5}
          border='1px solid #ECECEC'
          borderRadius='8px'
          bgcolor='white'
          sx={{
            fontFamily: 'monospace',
            fontSize: 12,
            whiteSpace: 'pre-wrap',
            overflowX: 'auto',
            wordBreak: 'break-word'
          }}
        >
          {callId && `tool_call_id: ${callId}\n`}
          {formatToolJson(content)}
        </Box>
      )}
    </Box>
  );
}
